export default __webpack_public_path__ + "static/img_interviewee_okwon@2x-e938283ce8da493d276b48c38af1fca2.png";